module.exports = __webpack_public_path__ + "static/media/heart-white.60edca80.svg";